var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { InternalMessageBusChannels, internalMessageBus } from "sb-internal-msg-bus";
import { Cookies } from "sb-helpers";
import { computed, action, observable } from "mobx";
import { FavoriteItem } from "../../typings";
// 1.5 hours
const EXPIRE_TIME = 0.063;
export class FavoritesManager {
    constructor(cookieName) {
        this.cookieName = cookieName;
        this.favorites = observable([]);
    }
    /* istanbul ignore next */
    // Cookies cannot be tested
    setCookie(favoriteEvents) {
        const favoritesCookie = favoriteEvents.map((favoriteEvent) => favoriteEvent.stringify());
        Cookies.set(this.cookieName, favoritesCookie.join(","), { expires: EXPIRE_TIME });
    }
    /* istanbul ignore next */
    // Cookies cannot be tested
    getCookie() {
        const favoritesInCookie = Cookies.get(this.cookieName);
        let favorites = favoritesInCookie ? favoritesInCookie.split(",") : [];
        return favorites.map((favoritePair) => new FavoriteItem(favoritePair));
    }
    emitFavoritesMessage(option) {
        internalMessageBus.emit(InternalMessageBusChannels.favoriteEvents[option]);
    }
    get favoriteEventIds() {
        return this.favorites.map((item) => item.eventId);
    }
    get favoriteSportIds() {
        return this.favorites.map((item) => item.sportId)
            .filter((id, i, array) => array.indexOf(id) === i);
    }
    add(eventToAdd) {
        this.favorites.push(eventToAdd);
        this.setCookie(this.favorites);
        this.emitFavoritesMessage("add");
    }
    remove(eventToRemove) {
        this.favorites.replace(this.favorites.filter((item) => item.eventId !== eventToRemove.eventId));
        this.setCookie(this.favorites);
        this.emitFavoritesMessage("remove");
    }
    loadFavorites() {
        this.favorites.replace(this.getCookie());
    }
    manageFavorites(event) {
        const item = new FavoriteItem();
        item.setValues(event.sportId, event.id);
        this.isInFavorites(event.id) ? this.remove(item) : this.add(item);
    }
    isInFavorites(eventId) {
        return this.favorites.some((item) => item.eventId === eventId);
    }
    get getFavorites() {
        return this.favorites;
    }
}
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], FavoritesManager.prototype, "favoriteEventIds", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], FavoritesManager.prototype, "favoriteSportIds", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [FavoriteItem]),
    __metadata("design:returntype", void 0)
], FavoritesManager.prototype, "add", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [FavoriteItem]),
    __metadata("design:returntype", void 0)
], FavoritesManager.prototype, "remove", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FavoritesManager.prototype, "loadFavorites", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FavoritesManager.prototype, "getFavorites", null);
//# sourceMappingURL=FavoritesManager.js.map